export class SpreadsheetConsts {
    public static options: string = 'options';
    public static row: string = 'row';
    public static column: string = 'column';
    public static innerTotal: string = 'total';
}